export default [
    {
        path: '/invoiceManage/upload',
        name: '订单关联',
        component: () => import('@/pages/invoice/invoice-manage'),
        icon: 'none'
    },
    {
        path: '/invoiceManage/query',
        name: '发票查询',
        component: () => import('@/pages/invoice/invoice-list'),
        icon: 'none'
    },
    {
        path: '/invoice/edit',
        name: '发票信息',
        component: () => import('@/pages/invoice/invoice-edit'),
        icon: 'none'
    }
]


// WEBPACK FOOTER //
// ./src/router/invoice.js